import { ErrorController } from "./error";
import { MissingConsentController } from "./missing-consent";
import { NotFoundController } from "./not-found-controller";
import { SignInReauthorizationController } from "./sign-in-reauthorization-controller";
import app from "../sdAppModule";

app
  .controller("ErrorController", ErrorController)
  .controller("MissingConsentController", MissingConsentController)
  .controller("notFoundController", NotFoundController)
  .controller("signInReauthorizationController", SignInReauthorizationController);
